import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ChevronLeft, Lock, EyeOff, FileText, Bell } from 'lucide-react';
import { AcShieldLogo } from '../../components/security/AcShieldLogo';

export function PoliticaPrivacidadePage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#F5F0E8', // var(--cream)
      color: '#4A4540', // var(--gray-700)
      fontFamily: "'Inter', -apple-system, sans-serif",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '40px 20px'
    }}>
      {/* Header com Logo e Voltar */}
      <div style={{
        width: '100%',
        maxWidth: '900px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '40px',
        borderBottom: '1px solid #E8E0D4', // var(--cream-dark)
        paddingBottom: '20px'
      }}>
        <Link to="/" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#1B365D', // var(--navy)
          textDecoration: 'none',
          fontSize: '0.9rem',
          fontWeight: 600,
          transition: 'color 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = '#2A4A7F'}
        onMouseLeave={(e) => e.currentTarget.style.color = '#1B365D'}
        >
          <ChevronLeft size={18} />
          Voltar ao Início
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: 28, height: 28, color: '#1B365D' }}>
            <AcShieldLogo style={{ width: '100%', height: '100%' }} />
          </div>
          <span style={{ fontSize: '1.2rem', fontWeight: 800, color: '#1B365D' }}>
            Aluno <strong style={{ color: '#B86B47' }}>Conectado</strong>
          </span>
        </div>
      </div>

      {/* Container Principal */}
      <main style={{
        width: '100%',
        maxWidth: '900px',
        background: '#FFFFFF', // var(--white)
        border: '1px solid #E8E0D4',
        borderRadius: '16px',
        boxShadow: '0 8px 30px rgba(27, 54, 93, 0.08)', // var(--shadow-md)
        overflow: 'hidden'
      }}>
        {/* Banner de Imagem Fixo */}
        <div style={{
          width: '100%',
          height: '240px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <img 
            src="/assets/images/hero.png" 
            alt="Política de Privacidade" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover' 
            }} 
          />
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(27, 54, 93, 0.92) 0%, rgba(27, 54, 93, 0.4) 100%)'
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '24px',
            left: '40px',
            color: '#fff'
          }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(8px)', padding: '6px 16px', borderRadius: '50px', marginBottom: '12px' }}>
              <Shield size={14} style={{ color: '#fff' }} />
              <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#fff', letterSpacing: '1px', textTransform: 'uppercase' }}>Segurança & Privacidade</span>
            </div>
            <h1 style={{ fontSize: '2.2rem', fontWeight: 800, color: '#fff', margin: 0 }}>Política de Privacidade</h1>
          </div>
        </div>

        <div style={{ padding: '40px' }}>
          <p style={{ fontSize: '0.85rem', color: '#8A8478', marginBottom: '24px', fontWeight: 600 }}>
            Última atualização: 22 de julho de 2026
          </p>

          <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#4A4540', margin: '0 0 24px 0' }}>
            O Aluno Conectado é uma plataforma de tecnologia educacional desenvolvida e operada pela <strong>AC3 Soluções Tecnológicas Ltda.</strong>, inscrita no CNPJ sob o número <strong>18.809.453/0001-29</strong>. Este Aviso de Privacidade explica como os dados pessoais são coletados, utilizados, armazenados, compartilhados e protegidos durante a utilização do portal, dos aplicativos e dos serviços relacionados ao Aluno Conectado.
          </p>

        {/* Políticas Detalhadas */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '28px', fontSize: '0.92rem', lineHeight: '1.6' }}>
          
          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              1. Papéis no tratamento de dados
            </h2>
            <p>
              Nas implantações realizadas para prefeituras, secretarias de educação, escolas e demais instituições de ensino, a instituição contratante normalmente atua como <strong>controladora dos dados pessoais escolares</strong>, pois define as finalidades e as regras aplicáveis ao tratamento.
            </p>
            <p>
              A AC3 Soluções Tecnológicas Ltda. atua, em regra, como <strong>operadora</strong>, realizando o tratamento conforme as instruções da instituição contratante e os instrumentos firmados entre as partes.
            </p>
            <p>
              Em determinadas atividades próprias, como administração do portal, segurança da plataforma, suporte técnico, gestão de contas e prevenção a fraudes, a AC3 poderá atuar como controladora dos dados relacionados a essas operações.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              2. Dados pessoais tratados
            </h2>
            <p>
              Conforme as funcionalidades contratadas e habilitadas pela instituição de ensino, a plataforma poderá tratar:
            </p>
            <ul style={{ paddingLeft: '20px', margin: '8px 0', display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <li><strong>Dados de identificação:</strong> nome, CPF (quando necessário), data de nascimento, matrícula, escola, turma, série e vínculo com o responsável.</li>
              <li><strong>Dados de contato:</strong> endereço de e-mail, telefone e demais informações fornecidas para comunicação.</li>
              <li><strong>Dados escolares:</strong> frequência, notas, boletins, registros de atividades, diários de classe, comunicados e informações pedagógicas.</li>
              <li><strong>Dados de acesso e segurança:</strong> identificador do crachá ou tag RFID, horários de entrada e saída, registros de autenticação, endereço IP, informações do dispositivo e logs de auditoria.</li>
              <li><strong>Dados de responsáveis e profissionais:</strong> nome, contato, função, instituição vinculada e permissões de acesso.</li>
            </ul>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              3. Origem dos dados
            </h2>
            <p>
              Os dados podem ser fornecidos:
            </p>
            <ul style={{ paddingLeft: '20px', margin: '8px 0', display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <li>pela prefeitura, secretaria, escola ou instituição contratante;</li>
              <li>pelo próprio titular ou por seu responsável legal;</li>
              <li>por profissionais autorizados da instituição;</li>
              <li>por dispositivos e sistemas autorizados, como leitores RFID;</li>
              <li>automaticamente durante o uso do portal ou aplicativo, por meio de registros técnicos e de segurança.</li>
            </ul>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              4. Finalidades do tratamento
            </h2>
            <p>
              Os dados são tratados para:
            </p>
            <ul style={{ paddingLeft: '20px', margin: '8px 0', display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <li>cadastrar e identificar usuários autorizados;</li>
              <li>gerenciar escolas, turmas, alunos, responsáveis e profissionais;</li>
              <li>registrar frequência, entrada e saída de alunos;</li>
              <li>disponibilizar boletins, registros escolares e informações pedagógicas;</li>
              <li>enviar convites, confirmações, alertas e comunicados;</li>
              <li>realizar autenticação, recuperação de acesso e proteção de contas;</li>
              <li>prestar suporte técnico e prevenir acessos não autorizados, fraudes e incidentes;</li>
              <li>cumprir obrigações legais, regulatórias, administrativas e contratuais.</li>
            </ul>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              5. Bases legais
            </h2>
            <p>
              O tratamento poderá ser realizado, conforme o contexto e a responsabilidade da instituição controladora, para o cumprimento de obrigação legal ou regulatória, execução de políticas públicas, execução de contrato, proteção da vida ou da integridade física, exercício regular de direitos, legítimo interesse e consentimento, quando este for legalmente necessário.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              6. Dados de crianças e adolescentes
            </h2>
            <p>
              O tratamento de dados de crianças e adolescentes será realizado considerando prioritariamente seu melhor interesse, sua segurança, sua privacidade e seu desenvolvimento.
            </p>
            <p>
              A plataforma adota configurações de acesso restritas, controles por perfil e mecanismos destinados a limitar o acesso às informações escolares a responsáveis, profissionais e instituições devidamente autorizados. O Aluno Conectado não utiliza dados de crianças ou adolescentes para publicidade comportamental, comercialização de perfis ou direcionamento de anúncios.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              7. Comunicações transacionais por e-mail
            </h2>
            <p>
              O Aluno Conectado utiliza e-mails exclusivamente para comunicações operacionais e transacionais relacionadas à plataforma, incluindo: confirmações de cadastro, ativação de conta, convites de acesso, redefinição de senha, códigos de autenticação e alertas de segurança.
            </p>
            <p style={{ color: '#B86B47', background: 'rgba(184, 107, 71, 0.05)', padding: '12px', borderRadius: '8px', border: '1px solid rgba(184, 107, 71, 0.15)', marginTop: '8px' }}>
              <strong>Aviso Importante:</strong> O Aluno Conectado <strong>NÃO realiza campanhas promocionais, e-mails de marketing, telemarketing ou boletins informativos de vendas</strong>. Todos os e-mails disparados possuem caráter estritamente funcional e de segurança pública.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              8. Compartilhamento com terceiros
            </h2>
            <p>
              Os dados poderão ser compartilhados com a instituição responsável contratante, com profissionais autorizados da escola, com provedores de hospedagem, bancos de dados, segurança, autenticação e e-mail transacional (como o <strong>Twilio SendGrid</strong>, que atua como fornecedor tecnológico no processamento e entrega das mensagens). O Aluno Conectado não comercializa nem vende dados pessoais.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              9. Transferência internacional
            </h2>
            <p>
              Determinados fornecedores de infraestrutura e comunicação poderão processar dados pessoais fora do Brasil. Quando houver transferência internacional, serão adotados mecanismos e salvaguardas reconhecidos pela legislação brasileira, incluindo cláusulas contratuais de proteção de dados, medidas de segurança e obrigações aplicáveis aos fornecedores.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              10. Retenção e eliminação
            </h2>
            <p>
              Os dados serão mantidos durante o período necessário para executar os serviços contratados, cumprir obrigações legais e regulatórias, e atender as determinações da instituição contratante. Após o encerramento das finalidades aplicáveis, os dados serão eliminados ou anonimizados conforme a legislação vigente.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              11. Segurança da informação
            </h2>
            <p>
              Adotamos medidas técnicas e administrativas adequadas ao risco, incluindo controles de acesso baseados em perfis, registros de auditoria, criptografia em trânsito e isolamento lógico dos dados por instituição contratante.
            </p>
            <p>
              Em caso de incidentes de segurança que possam acarretar risco ou dano relevante aos titulares, tomaremos as medidas de resposta cabíveis e notificaremos as autoridades e titulares conforme determinado em lei.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              12. Direitos dos titulares
            </h2>
            <p>
              Conforme a LGPD, o titular ou seu representante legal poderá solicitar confirmação de tratamento, acesso, correção, eliminação de dados excessivos, informações sobre compartilhamento e revogação de consentimento (quando aplicável). Como a maior parte dos dados escolares é tratada sob responsabilidade da instituição de ensino (controladora), as solicitações de direitos de alunos deverão ser encaminhadas à respectiva escola ou rede de ensino para análise de base jurídica aplicável.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1B365D', margin: '0 0 12px 0' }}>
              13. Cookies e registros de navegação
            </h2>
            <p>
              O portal poderá utilizar cookies estritamente necessários para autenticação, segurança, manutenção da sessão e funcionamento dos serviços.
            </p>
          </section>

          <section style={{ borderTop: '1px solid #E8E0D4', paddingTop: '24px', marginTop: '12px' }}>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1B365D', margin: '0 0 8px 0' }}>Canal de Privacidade:</h3>
            <p style={{ margin: '0 0 12px 0' }}>
              Dúvidas ou solicitações relativas à privacidade e proteção de dados podem ser enviadas diretamente para o nosso e-mail oficial: <a href="mailto:contato@alunoconectado.com.br" style={{ color: '#B86B47', textDecoration: 'none', fontWeight: 600 }}>contato@alunoconectado.com.br</a>.
            </p>
          </section>

          <section style={{ borderTop: '1px solid #E8E0D4', paddingTop: '24px' }}>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1B365D', margin: '0 0 8px 0' }}>Identificação da Empresa:</h3>
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#4A4540' }}>
              <strong>AC3 Soluções Tecnológicas Ltda.</strong><br />
              CNPJ: 18.809.453/0001-29<br />
              Endereço cadastral: Avenida Portugal, 4340, Sala 101, Jardim Atlântico, Belo Horizonte – MG, CEP 31710-434.
            </p>
          </section>
        </div>
      </div>
    </main>

      {/* Footer Mínimo */}
      <footer style={{ 
        marginTop: '40px', 
        fontSize: '0.8rem', 
        color: '#8A8478', 
        textAlign: 'center', 
        lineHeight: '1.8',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link to="/" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Início</Link>
          <span>•</span>
          <Link to="/sobre" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Sobre Nós</Link>
          <span>•</span>
          <Link to="/politica-de-privacidade" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Política de Privacidade</Link>
          <span>•</span>
          <Link to="/cancelar-email" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Cancelar Recebimento</Link>
        </div>
        <div>
          <span>Avenida Portugal, 4340, Sala 101, Jardim Atlântico, Belo Horizonte - MG, CEP 31710-434</span>
          <span style={{ margin: '0 8px' }}>|</span>
          <span>Contato: (31) 3274-9340 | contato@alunoconectado.com.br</span>
        </div>
        <p style={{ margin: 0 }}>&copy; 2026 Aluno Conectado. Desenvolvido por AC3 Soluções Tecnológicas Ltda.</p>
      </footer>
    </div>
  );
}
